// Selectors
import { ApplicationState } from '../../store';


export const serviceProfileSelector = (state: ApplicationState) => state.serviceProfileState


